<template>
	<div>
		<v-dialog v-model="dialog_addUnit" no-click-animation persistent content-class="full-height" scrollable transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
        		<v-subheader full-width>Add Unit</v-subheader>
        	</v-card-title>
	        <v-divider></v-divider>
	        <!-- <v-card-text dialog-card-content>
	            <v-layout wrap>
	            	<v-form data-vv-scope="subvariant" full-width>
	            		<v-flex xs12 sm12 md12 form-item @click="openDialogUnits('ref_dialogAddUnit_subunit')">
			               <v-text-field  
			               		readonly 
			               		v-model="$parent.Form.variant.unitName" 
			               		label="Unit" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogAddUnit_subunit" 
			               		:onUpdate="updateSubUnit" 
			               		v-validate="'required'" 
			               		:error-messages="errors.collect('subvariant.unit')"  
			               		data-vv-name="unit" 
			               		required>
			               	</v-text-field>
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item v-if="!fixedCQty">
			               <v-text-field 
			               		 
			               		v-model.number="$parent.Form.variant.packQuantity" 
			               		type="number" 
			               		label="Pack QTY" 
			               		placeholder=" " 
			               		v-validate="'required|numeric|min_value:1'" 
			               		:error-messages="errors.collect('subvariant.packQty')"  
			               		data-vv-name="packQty" 
			               		data-vv-as="pack qty" 
			               		required>
			               	</v-text-field>
			            </v-flex>
	            	</v-form>
	              
	            </v-layout>

	        </v-card-text> -->
	        
			<v-card-text dialog-card-content>
				<v-form data-vv-scope="subvariant" full-width>
	            <v-layout wrap>
	            		<v-flex xs12 sm12 md12 form-item @click="fn_openUnits('primary')">
			               <v-text-field  
								:disabled="unitInUse"
			               		readonly 
			               		v-model="$parent.Form.primaryUnitName" 
			               		label="Primary Unit" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogAddUnit_primary" 
			               		:onUpdate="updatePrimaryUnit" 
			               		v-validate="'required'" 
			               		:error-messages="errors.collect('subvariant.primaryUnit')"  
			               		data-vv-name="primaryUnit" 
								data-vv-as="primary unit" 
								@input="fn_getUnitPacks"
			               		required>
			               	</v-text-field>
			            </v-flex>

						<v-flex xs12 sm12 md12 form-item @click="fn_openUnits('secondary')">
			               <v-text-field  
			               		readonly 
			               		v-model="$parent.Form.secondaryUnitName" 
			               		label="Secondary Unit" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		ref="ref_dialogAddUnit_secondary" 
			               		:onUpdate="updateSecondaryUnit" 
								clearable
								@input="fn_checkClearSecondary"
			               		required>
			               	</v-text-field>
			            </v-flex>

						<!-- <v-flex xs12 sm12 md12 right-align><v-btn color="primary" flat small capitalize>Remove Secondary Unit</v-btn></v-flex> -->
						

			            <!-- <v-flex xs12 sm12 md12 form-item v-if="!fixedCQty">
			               <v-text-field 
			               		 
			               		v-model.number="$parent.Form.variant.packQuantity" 
			               		type="number" 
			               		label="Pack QTY" 
			               		placeholder=" " 
			               		v-validate="'required|numeric|min_value:1'" 
			               		:error-messages="errors.collect('subvariant.packQty')"  
			               		data-vv-name="packQty" 
			               		data-vv-as="pack qty" 
			               		required>
			               	</v-text-field>
			            </v-flex> -->
	              
	            </v-layout>

				<v-layout row wrap>
					<template v-if="$parent.Form.secondaryUnitName">
							<v-flex xs12 sm12 md12 pa-3>Conversion Rate</v-flex>

							<v-flex xs5 sm5 md5 pl-3>
								<v-text-field
									:label="$parent.Form.primaryUnitName"
									placeholder=" "
									v-model="$parent.Form.primaryUnitPackQuantity"
									v-validate="'required|decimal:4'" 
									:error-messages="errors.collect('subvariant.packQty')"  
									data-vv-name="packQty" 
									data-vv-as="pack qty" 
									type="number"
									required
								></v-text-field>
							</v-flex>

							<v-flex xs2 sm2 md2 center-align style="display: flex; align-items: center;justify-content: center;">=</v-flex>

							<v-flex xs5 sm5 md5 pr-3>
								<v-text-field
									:label="$parent.Form.secondaryUnitName"
									placeholder=" "
									v-model="$parent.Form.secondaryUnitPackQuantity"
									v-validate="'required|decimal:4'" 
									:error-messages="errors.collect('subvariant.secondaryPackQty')"  
									data-vv-name="secondaryPackQty" 
									data-vv-as="secondary pack qty" 
									type="number"
									required
								></v-text-field>
							</v-flex>
						</template>
				</v-layout>

				</v-form>

				<!-- <v-layout row wrap>
					<template v-if="$parent.Form.secondaryUnitName">
							<v-flex xs12 sm12 md12 pa-3>Conversion Rate</v-flex>

							<v-flex xs5 sm5 md5 pl-3>
								<v-text-field
									:label="$parent.Form.primaryUnitName"
									placeholder=" "
									v-model="$parent.Form.primaryUnitPackQuantity"
									v-validate="'required|decimal:4'" 
									:error-messages="errors.collect('subvariant.packQty')"  
									data-vv-name="packQty" 
									data-vv-as="pack qty" 
									type="number"
									required
								></v-text-field>
							</v-flex>

							<v-flex xs2 sm2 md2 center-align style="display: flex; align-items: center;justify-content: center;">=</v-flex>

							<v-flex xs5 sm5 md5 pr-3>
								<v-text-field
									:label="$parent.Form.secondaryUnitName"
									placeholder=" "
									v-model="$parent.Form.secondaryUnitPackQuantity"
									v-validate="'required|decimal:4'" 
									:error-messages="errors.collect('subvariant.secondaryPackQty')"  
									data-vv-name="secondaryPackQty" 
									data-vv-as="secondary pack qty" 
									type="number"
									required
								></v-text-field>
							</v-flex>
						</template>
				</v-layout> -->

				<v-list nopadding v-if="$parent.Form.secondaryUnitName">
					<template v-for="(item, index) in unitPacks">
						<v-list-tile :Key="index" @click="fn_selectUnitPack(item)">
							<v-list-tile-action style="min-width: 40px;">
								<v-icon :color="item.selected ? 'primary' : ''">{{ item.selected ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>
									{{item.primaryPackQuantity}} {{ item.primaryUnitName }} = {{item.secondaryUnitPackQuantity}} {{item.secondaryUnitName}}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>
				</v-list>

	        </v-card-text>
			<v-divider></v-divider>
	        <!-- <v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click.native="fn_saveVariant">ok</v-btn>
	        </v-card-actions> -->
			<v-card-actions>
	          <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click.native="fn_saveUnit">done</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	// props:['openDialogUnits', 'updateSubUnit', 'checkSubVariantValidations', 'fixedCQty'],
	props:['openDialogUnits', 'updatePrimaryUnit', 'updateSecondaryUnit', 'checkSubVariantValidations', 'fixedCQty'],
	data(){	
		return{
			dialog_addUnit: false,
			unitPacks:null,
			unitInUse:false
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_addUnit = true;
			if(this.$parent.Form.productId){
				this.fn_verifyUnit();
			}
			this.fn_getUnitPacks();
		},
		closeDialogWeb: function () {
			this.dialog_addUnit = false;
		},

		fn_openUnits: function(type){
			if(type == 'secondary' || (type == 'primary' && !this.unitInUse)){
				if(type == 'secondary'){
					this.openDialogUnits('ref_dialogAddUnit_secondary');	
				}
				else{
					this.openDialogUnits('ref_dialogAddUnit_primary');
				}
			}
		},

		fn_checkClearSecondary: function(val){
			if(!val){
				this.$parent.Form.secondUnitId = null;
				this.$parent.Form.secondUnitName = null;
				this.$parent.Form.secondaryUnitId = null;
				this.$parent.Form.secondaryUnitName = null;
				this.$parent.Form.packQuantity = null;
				this.$parent.Form.primaryUnitPackQuantity = null;
				this.$parent.Form.secondaryUnitPackQuantity = null;
				this.unitPacks = null;
			}
			else{
				this.fn_getUnitPacks();
			}
		},
		// fn_saveVariant: function () {
		// 	var self = this;
		//     this.$validator.validateAll('subvariant').then((result) => {
		//         if (result) {
		//            this.checkSubVariantValidations(this.$parent.Form.variant, false)
		//         }
		//     });
		// }
		fn_saveUnit: function () {
		    this.$validator.validateAll('subvariant').then((result) => {
		        if (result) {
					if(this.$parent.Form.secondaryUnitId && this.$parent.Form.secondaryUnitId == this.$parent.Form.primaryUnitId){
						this.showToast("Primary and Secondary units shouldn't be same");
						return;
					}

					this.$parent.Form.unitId = this.$parent.Form.primaryUnitId;
					this.$parent.Form.unitName = this.$parent.Form.primaryUnitName;

					if(this.$parent.Form.secondaryUnitId){
						this.$parent.Form.secondUnitId = this.$parent.Form.secondaryUnitId;	  
						this.$parent.Form.secondUnitName = this.$parent.Form.secondaryUnitName;
						!this.$parent.Form.primaryUnitPackQuantity ? this.$parent.Form.primaryUnitPackQuantity = 1 : '';
					}
					else{
						this.$parent.Form.secondUnitId = null;	  
						this.$parent.Form.secondUnitName = null;
						this.$parent.Form.secondaryUnitPackQuantity = null;
					}

					if(this.$parent.Form.selectedOpeningUnitId && (this.$parent.Form.selectedOpeningUnitId != this.$parent.Form.unitId && this.$parent.Form.selectedOpeningUnitId != this.$parent.Form.secondUnitId)){
						this.$parent.Form.selectedOpeningUnitId = this.$parent.Form.unitId;
						this.$parent.Form.selectedOpeningUnitName = this.$parent.Form.unitName;
					}

					this.$parent.fn_closeDialog();
				}
		    });
		},

		fn_getUnitPacks: function(){
			if(this.$parent.Form.secondaryUnitId){
				let self = this;
				let filterObject = {};
				filterObject.primaryUnitId = this.$parent.Form.primaryUnitId;
				filterObject.secondaryUnitId = this.$parent.Form.secondaryUnitId;
				this.getFilterData('GetUnitQuantities', null, filterObject,
					{
						onSuccess: function(response){
						console.log(response);
						self.unitPacks = JSON.parse(response);
						if(self.unitPacks && self.unitPacks.length){
							for(let i=0; i<self.unitPacks.length; i++){
								self.unitPacks[i].selected = false;

								if(self.unitPacks[i].primaryPackQuantity == self.$parent.Form.primaryUnitPackQuantity && self.unitPacks[i].secondaryUnitPackQuantity == self.$parent.Form.secondaryUnitPackQuantity){
									self.unitPacks[i].selected = true;
								}
							}
						}
					},
						onError: function(error){
						console.log(error);
					}
				});	
			}
		},

		fn_selectUnitPack: function(item){
			for(let i=0; i<this.unitPacks.length; i++){
				this.unitPacks[i].selected = false;
			}
			item.selected = true;

			this.$parent.Form.primaryUnitPackQuantity = item.primaryPackQuantity;
			this.$parent.Form.secondaryUnitPackQuantity = item.secondaryUnitPackQuantity;
		},

		fn_verifyUnit: function(){
			let self = this;
			let filterObject = {};
			filterObject.productId = this.$parent.Form.productId;
			filterObject.unitId = this.$parent.Form.primaryUnitId;
			this.getFilterData('VerifyUnit', null, filterObject, 
				{
					onSuccess: function(response){
						console.log(response);
						self.unitInUse = JSON.parse(response);
					}, 
					onError: function(error){
						console.log(error);
					}
				}
			);
		},
		
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/dialogs/dialog_add_unit.vue